import { enqueueSnackbar, type OptionsObject, type SnackbarKey } from "notistack";
import type { ApiErrorSeverity } from "@/types/common";

type EnqueueUiErrorParams = {
	message: string;
	variant?: ApiErrorSeverity;
	options?: Omit<OptionsObject, "variant">;
};

export function formatUiErrorMessage(message: string): string {
	return String(message ?? "").trim() || "Ocorreu um erro inesperado.";
}

export function enqueueUiError({ message, variant = "error", options }: EnqueueUiErrorParams): SnackbarKey {
	return enqueueSnackbar(formatUiErrorMessage(message), {
		variant,
		...options,
	});
}
